import { toast } from "react-toastify";

import api from "../../api";
import { canLoadStoreContext, getToken } from "../../auth";

import { formatResponse } from "../../formatResponses/global";
import { useMerchant } from "../../../store/global/useMerchant";

export default class MerchantModel {
  setMerchantValues = useMerchant.getState().actions.setMerchant;

  findMerchant = async () => {
    if (!canLoadStoreContext()) return false;
    const token = getToken();
    const isCurrentSession = () => token === getToken() && canLoadStoreContext();

    try {
      const { data } = await api.get("store");
      if (!isCurrentSession()) return false;
      const formattedMerchant = formatResponse.merchant(data);

      this.setMerchantValues(formattedMerchant);
      return formattedMerchant;
    } catch (error) {
      if (!isCurrentSession()) return false;
      // const msg =
      //   error.response?.data?.friendly_message ||
      //   error.message ||
      //   'Não foi possível carregar os dados da loja.'
      // toast.error(msg, { theme: 'colored' })
      return false
    }
  };
}
